import JSX, { h, ComponentChildren } from 'preact'
import DropdownList from './DropdownList'
import Dropdown from './index'
import { GroupedItemsList, ItemsList } from './interfaces'

interface Props {
    type?: string,
    align: string,
    trigger: ComponentChildren,
    items: ItemsList | GroupedItemsList,
    displayListUpwards?: boolean,
    hasSearch?: boolean,
    triggerClass?: string,
    disabled?: boolean,
    children?: JSX.Element,
    newStyle?: boolean,
    closeOnDropdownClick?: boolean,
    className?: string,
    showDefaultChildren?: boolean
}

const DropdownControl = ({ type, align, trigger, items, displayListUpwards, hasSearch, triggerClass, disabled, children, newStyle, className, closeOnDropdownClick, showDefaultChildren }: Props) => {
  return (
    <Dropdown
      closeOnDropdownClick={closeOnDropdownClick || false}
      popupName='control-dropdown'
      class={`control-dropdown${newStyle ? ' control-dropdown--brand' : ''} ${className || ''}`}
      trigger={trigger}
      triggerClass={triggerClass}
      disabled={disabled}
    >
      {
        showDefaultChildren ? ({ close } : { close: () => void }) => children.length ? children[0]({ close }) : <DropdownList
          displayListUpwards={displayListUpwards}
          type={type}
          align={align}
          items={items}
          hasSearch={hasSearch || false}
        /> : <DropdownList
          displayListUpwards={displayListUpwards}
          type={type}
          align={align}
          items={items}
          hasSearch={hasSearch || false}
        />
      }
    </Dropdown>
  )
}

export default DropdownControl
